import React from 'react'
import Slide, { CANVAS_H, CANVAS_W } from './Slide.js'
import { slidesByLocale, type Locale } from './slides.js'

/**
 * App Store 截图生成页。
 *
 * 两种模式：
 * - `/app-screenshot`：画廊，中英两套并排看，用来肉眼过稿。
 * - `/app-screenshot?only=3&lang=zh`：只渲染一张，占满视口且无外边距 ——
 *   导出脚本用无头 Chrome 以 440x956 视口 + 3x DPR 截这一张，直接得到 1320x2868。
 */
export default function AppScreenshot() {
  const params = new URLSearchParams(window.location.search)
  const only = params.get('only')
  const lang = (params.get('lang') === 'en' ? 'en' : 'zh') as Locale

  if (only) {
    const slide = slidesByLocale[lang].find((s) => String(s.id) === only)
    if (!slide) return <div>no slide {only}</div>
    return (
      <div style={{ margin: 0, padding: 0, width: CANVAS_W, height: CANVAS_H }}>
        <Slide slide={slide} />
      </div>
    )
  }

  return (
    <div style={{ padding: 24, background: '#20262B', minHeight: '100vh' }}>
      {(['zh', 'en'] as Locale[]).map((locale) => (
        <div key={locale} style={{ marginBottom: 40 }}>
          <div style={{ color: '#fff', fontSize: 18, fontWeight: 700, marginBottom: 12 }}>
            {locale === 'zh' ? '简体中文' : 'English'}
          </div>
          <div style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 12 }}>
            {slidesByLocale[locale].map((slide) => (
              <div
                key={slide.id}
                style={{
                  flex: '0 0 auto',
                  borderRadius: 14,
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
                }}
              >
                <Slide slide={slide} />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
